import { Box, IconButton, IconButtonProps, Typography } from "@mui/material"
import { useContextState } from "../../hooks/theme"
import { useNavigate } from "react-router-dom"
import { icons } from "../../utils/icons";

const GoBack = ({ path, title, arrowProps, color, state }: { path?: string; title?: string; arrowProps?: IconButtonProps, color?: 'primary'; state?: any }) => {
    const { colors } = useContextState()
    const navigate = useNavigate()

    return (
        <Box sx={{
            marginLeft: '-8px',
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                color: color ? colors.primary : colors.color4,
                fontWeight: '600',
            },
            '& .MuiTypography-root': {
                color: color ? colors.primary : colors.color12,
                fontSize: '17px',
                fontWeight: '500'
            }
        }}>
            <IconButton onClick={() => { if (path) { navigate(path, { state }) } }} {...arrowProps ?? {}}>{icons('arrow-left-fill')}</IconButton>

            <Typography variant="title">{title ?? 'Regresar'}</Typography>
        </Box>
    )
}

export { GoBack }
